import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import AdditionalInformation from "../../components/additional-information"
import ContentTransformer from "../../components/Transformers/content-transformer"
import {
  pageAddress,
  pageAddressAdditionalInfos,
  addressContent,
  addressContentContainer,
  addressTitle,
  addressAddress,
  separator,
  addressBody,
  addressContact,
  addressMail,
  addressTel,
  addressFooter,
  addressFooterBack,
  addressPlace,
  addressPlaceIcon,
  addressPlaceTitle,
  addressCarouselContainer,
  editButton,
} from "./styles/detailsAddress.module.scss"
import Carousel from "../../components/Carousel/carousel"
import PropTypes from "prop-types"
import {
  AdditionalInfos,
  AdressTitle,
  Separator,
  AdressPlaceIcon,
  AdressPlaceTitle,
  AdressFooterContainer,
} from "./styled-components/adresse-styled"
import TransitionFade from "../../components/transition-fade"
import FadeIn from "react-fade-in"
import Ariane from "../../components/Ariane/ariane"
import Obfuscate from "react-obfuscate"
import ProcessedLink from "../../components/processed-link"
import EditButton from "../../components/EditButton/edit-button"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeCarnetDAdresse(path: { alias: { eq: $slug } }) {
      ...AdresseItem
    }
  }
`

//-----------------------QueryGraphql---------------------------//

//-----------------------Parent Component---------------------------//

const AdresseTemplate = ({ data }) => {
  const addressBook = data.nodeCarnetDAdresse
  const allTaxos = addressBook.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout isDetail={true}>
      <SEO
        title={addressBook.title}
        description={
          "Dans cette page, vous découvrez l'adresse suivante : " +
          addressBook.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
        nodeImageUrl={
          addressBook.relationships?.field_image_adresse?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <Ariane
        pageNameLink="/adresses"
        pageName="Carnet d'adresses"
        isDetail={true}
        postName={addressBook.title}
      />
      <FadeIn delay={150}>
        <section className={pageAddress}>
          <AddressContent address={addressBook} />
          <div className={addressCarouselContainer}>
            <Carousel address={addressBook} />
          </div>
          <AddressFooter />
        </section>
        <AddressInfos address={addressBook} />
      </FadeIn>
    </Layout>
  )
}

//-----------------------Parent Component---------------------------//

//-----------------------Child Component/Content---------------------------//

const AddressContent = ({ address }) => (
  <div className={addressContent}>
    <article className={addressContentContainer}>
      <AdressTitle className={addressTitle}>
        <EditButton
          link={"/node/" + address.drupal_internal__nid + "/edit"}
          addedClass={editButton}
        />
        {address.title}
      </AdressTitle>
      <div className={addressAddress}>
        <p>{address.field_adresse?.address_line1}</p>
        <p>{address.field_adresse?.address_line2}</p>
        <p>
          {address.field_adresse?.postal_code} {address.field_adresse?.locality}
        </p>
      </div>
      <AddressContact address={address} />
    </article>
    <Separator className={separator}></Separator>
    <div className={addressBody}>
      <ContentTransformer content={address.body?.processed} />
    </div>
    {address.field_url_lieu && (
      <div className={addressPlace}>
        <ProcessedLink link={address.field_url_lieu.uri}>
          <AdressPlaceIcon
            className={addressPlaceIcon}
            size={30}
            icon="earth"
          ></AdressPlaceIcon>
          <AdressPlaceTitle className={addressPlaceTitle}>
            {address.field_url_lieu.title}
          </AdressPlaceTitle>
        </ProcessedLink>
      </div>
    )}
  </div>
)

//-----------------------Child Component/Content---------------------------//

//-----------------------Child Component/Footer---------------------------//

const AddressFooter = () => (
  <AdressFooterContainer className={addressFooter}>
    <div className={addressFooterBack}>
      <TransitionFade
        arialabel="Retour à la liste des carnets d'adresses"
        link="/adresses"
      >
        Retour à la liste des carnets d&apos;adresses
      </TransitionFade>
    </div>
  </AdressFooterContainer>
)

//-----------------------Child Component/Footer---------------------------//

//-----------------------Child Component/Infos---------------------------//

const AddressInfos = ({ address }) => (
  <>
    {address.field_infos_complementaires && (
      <AdditionalInfos className={pageAddressAdditionalInfos}>
        <AdditionalInformation node={address} />
      </AdditionalInfos>
    )}
  </>
)

//-----------------------Child Component/Infos---------------------------//

//-----------------------Sub-Child Component/Contact---------------------------//

const AddressContact = ({ address }) => (
  <>
    <div className={addressContact}>
      {address.field_mail && (
        <Obfuscate email={address.field_mail} className={addressMail} />
      )}
      {address.field_telephone && (
        <Obfuscate tel={address.field_telephone} className={addressTel} />
      )}
    </div>
  </>
)

//-----------------------Sub-Child Component/Contact---------------------------//

//-----------------------Prop-Types---------------------------//

AdresseTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}
AddressContent.propTypes = {
  address: PropTypes.object.isRequired,
}
AddressContact.propTypes = {
  address: PropTypes.object.isRequired,
}
AddressInfos.propTypes = {
  address: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default AdresseTemplate
